export const GET_CASETYPES = "GET_CASETYPES";
export const GET_ISSUETYPES = "GET_ISSUETYPES";
